// extracted by mini-css-extract-plugin
export var Banner = "index-module--Banner--vzsZC";
export var BannerIcon = "index-module--BannerIcon--9rz3P";
export var CourseCard = "index-module--CourseCard--Ad9JL";
export var educationFooter = "index-module--educationFooter--XL0db";
export var linkBtn = "index-module--linkBtn--sUaWl";
export var textBtn = "index-module--textBtn--Ke7Dd";